import type { Styles } from '@adornis/ass/style.js';
import { DesignSystem } from '@adornis/chemistry/elements/theming/design.js';

const designSystem = () => DesignSystem.currentTheme.getValue();

export const badgeStyle = (): Styles => ({
  fontSize: '0.8em',
  padding: '8px',
  borderRadius: designSystem().sizes.borderRadius,
  border: '1px solid transparent',
  width: 'min-content',
  letterSpacing: '-0.1pt',
  userSelect: 'none',
  textWrap: 'nowrap',
});

export const badgeStyleSm = (): Styles => ({
  padding: '3px 6px',
});

export const badgeStylePositive = (): Styles => ({
  ...badgeStyle(),
  background: designSystem().colors.tone.success,
  color: designSystem().colors.on.tone.success,
});

export const badgeStyleNeutral = (): Styles => ({
  ...badgeStyle(),
  background: designSystem().colors.neutral.shade(100).string,
  color: designSystem().colors.on.neutral.shade(100).string,
});

export const badgeStyleNegative = (): Styles => ({
  ...badgeStyle(),
  background: designSystem().colors.tone.error,
  color: designSystem().colors.on.tone.error,
});

export const badgeStylePositiveSm = (): Styles => ({
  ...badgeStylePositive(),
  ...badgeStyleSm(),
});

export const badgeStyleNeutralSm = (): Styles => ({
  ...badgeStyleNeutral(),
  ...badgeStyleSm(),
});

export const badgeStyleNegativeSm = (): Styles => ({
  ...badgeStyleNegative(),
  ...badgeStyleSm(),
});
